import axios from 'axios';

const API_BASE_URL = 'https://erp.sondermallpalace.com/api';

const apiService = {
  get: async (url, config = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${url}`, config);
      return response.data;
    } catch (error) {
      console.error('GET request error:', error);
      throw error;
    }
  },

  post: async (url, data, config = {}) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${url}`, data, config);
      return response.data;
    } catch (error) {
      console.error('POST request error:', error);
      throw error;
    }
  },

  put: async (url, data, config = {}) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${url}`, data, config);
      return response.data;
    } catch (error) {
      console.error('PUT request error:', error);
      throw error;
    }
  },

  patch: async (url, data, config = {}) => {
    try {
      const response = await axios.patch(`${API_BASE_URL}${url}`, data, config);
      return response.data;
    } catch (error) {
      console.error('PATCH request error:', error);
      throw error;
    }
  },

  delete: async (url, config = {}) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}${url}`, config);
      return response.data;
    } catch (error) {
      console.error('DELETE request error:', error);
      throw error;
    }
  },
};

export default apiService;
